import React, { useState } from 'react';

import Button from 'CommonComponents/Button';
import FormInput from 'CommonComponents/FormInput';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';
import SelectInput from 'CommonComponents/SelectInput';

function AccountsDelete(props) {
    const defaultErrors = {
        name: null,
    };

    const [request, setRequest] = useState(false);
    const [formErrors, setFormErrors] = useState(defaultErrors);
    const [name, setName] = useState('');
    const [deleteUsers, setDeleteUsers] = useState('no');
    const [accountIsDeleted, setAccountIsDeleted] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const deleteAccount = () => {
        if (validateName(name)) {
            return;
        }

        setRequest(true);
        axios
            .delete(props.deleteEventsUrl, { data: { eventId: props.account?.id, deleteUsers } })
            .then((response) => {
                onModalClose();
            })
            .catch((e) => {
                setRequestFailed(true);
            });
    };

    const nameChange = (e) => {
        setName(e.target.value);
    };

    const deleteUsersChange = (e) => {
        setDeleteUsers(e.target.value);
    };

    const onModalClose = () => {
        setRequest(false);
        setAccountIsDeleted(false);
        setName('');
        props.successDeletedHandler();
    };

    const validateName = (name) => {
        let nameValue = name.toLowerCase() !== (props.account ? props.account.name.toLowerCase() : '') ? 'Does not Match' : undefined;
        const errors = {
            name: nameValue,
        };
        setFormErrors(errors);
        return errors['name'];
    };

    const labelContent = () => {
        return `To delete the event, please type its name <b>${props.account?.name}</b>: *`;
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Delete Account')} close={props.closeHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.account && (
                            <div className="modal__form-container">
                                <div className={!accountIsDeleted && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                    <div className="tw-grid tw-grid-cols-1">
                                        <FormInput
                                            isHtmlLabel={true}
                                            label={labelContent()}
                                            type="text"
                                            id="inputName"
                                            placeholder="Name"
                                            value={name}
                                            onChange={nameChange}
                                            onBlur={() => {
                                                validateName(name);
                                            }}
                                            showError={formErrors.name}
                                            errorText={formErrors.name}
                                        ></FormInput>
                                    </div>
                                    <div className="tw-grid tw-grid-cols-1">
                                        <SelectInput
                                            label={$t('Delete Users') + '?'}
                                            required={true}
                                            id="inputdeleteUsers"
                                            value={deleteUsers}
                                            onChange={deleteUsersChange}
                                            showError={formErrors.deleteUsers}
                                            errorText={formErrors.deleteUsers}
                                        >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </SelectInput>
                                    </div>
                                    <ModalFooter
                                        cancelButtonText={$t('Close')}
                                        primaryButtonText={$t('Delete')}
                                        onCancel={props.closeHandler}
                                        handleSubmit={deleteAccount}
                                        isSubmitting={request}
                                    ></ModalFooter>
                                </div>
                                <div className={accountIsDeleted ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                    <label className="modal__msg modal__text-color">[{props.account.name}] deleted</label>
                                </div>
                                <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                    <label className="modal__msg modal__error-text-color">[{props.account.name}] could not be deleted</label>
                                </div>

                                {(accountIsDeleted || requestFailed) && (
                                    <div className="modal__footer">
                                        <Button variant="secondary" onClick={onModalClose}>
                                            {$t('Close')}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountsDelete;
